/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import { getGetAPIMethod } from '@neum/frontend-shared/utils/api';

export const GetUserVisits  = getGetAPIMethod('/v1/analytics/user_visits', { baseUrl: import.meta.env.REACT_APP_ENDPOINT });

export const GetUserVisitsByOrg  = getGetAPIMethod('/v1/analytics/user_visits_by_org', { baseUrl: import.meta.env.REACT_APP_ENDPOINT });

export const GetOrgVisits  = getGetAPIMethod('/v1/analytics/org_visits', { baseUrl: import.meta.env.REACT_APP_ENDPOINT });

export const GetOrgUtil  = getGetAPIMethod('/v1/analytics/org_util', { baseUrl: import.meta.env.REACT_APP_ENDPOINT });
